import React, { useState } from 'react';
import { FaChevronDown, FaQuestionCircle } from 'react-icons/fa';
import './FAQSection.css';

const faqs = [
  {
    question: "Why choose RAD EnviroNex for Solar in Madurai?",
    answer: "We are \#1 in Madurai for Solar & Waste Water Treatment, providing customized solar solutions that maximize energy generation while reducing costs. Our 300+ 5-star ratings reflect our commitment to quality and customer satisfaction."
  },
  {
    question: "What industries do you serve with STP/ETP solutions?",
    answer: "We serve a wide range of industries globally, including manufacturing units, commercial establishments, hospitals, educational institutions, and residential housing societies, ensuring regulatory compliance and water sustainability."
  },
  {
    question: "How long does a typical solar installation take?",
    answer: "A standard rooftop solar installation for homes or small businesses typically takes 3-7 days after site assessment and design approval. Larger industrial projects may take longer depending on scale."
  },
  {
    question: "Do you provide environmental audits for industries?",
    answer: "Yes, we specialize in Energy Audits, Green Audits, and Environmental Audits. Our certified professionals identify inefficiencies and provide actionable insights for long-term sustainability and compliance."
  },
  {
    question: "What is the maintenance required for Biogas systems?",
    answer: "Biogas systems require minimal but consistent maintenance, such as regular monitoring of feed quality and ensuring there are no gas leaks. RAD EnviroNex provides full support and AMC for all our installations."
  }
];

const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section id="faq" className="faq-section">
      <div className="container" data-aos="fade-up">
        <div className="section-header">
          <h2 className="faq-heading"><FaQuestionCircle /> Frequently Asked Questions</h2>
          <p className="faq-sub">Common queries about our environmental and energy solutions</p>
        </div>
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className={`faq-item ${activeIndex === index ? 'active' : ''}`}
              onClick={() => toggleAccordion(index)}
            >
              <div className="faq-question">
                <span>{faq.question}</span>
                <FaChevronDown className="chevron" />
              </div>
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
